import { render, staticRenderFns } from "./NotGradedResponses.vue?vue&type=template&id=e6b77366&"
import script from "./NotGradedResponses.vue?vue&type=script&lang=js&"
export * from "./NotGradedResponses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports